import { createSlice } from '@reduxjs/toolkit';










const initialState = {
  intervalUnit: '',
  essDataConsumpData: {},
  tesDataConsumpData: {},
  tgsDataConsumpData: {},
  essSwitchData: {},
  tesSwitchData: {},
  tgsSwitchData: {},
  doublesSidedChartData: {},
  hpElectricData: {},
  hpGasData: {},
  hpDataConsumpData: {},
};

const telemetryChartDataSlice = createSlice({
  name: 'telemetryChartData',
  initialState,
  reducers: {
    setTelemetryChartData: (state, action) => {
      const { swtName, data } = action.payload;
      if (!state[swtName]) state[swtName] = {};
      Object.keys(data).forEach((objectKey) => {
        state[swtName][objectKey] = data[objectKey];
      });
    },
    setTelemetryIntervalUnit: (state, action) => {
      state.intervalUnit = action.payload;
    },
  },
});

export default telemetryChartDataSlice;
export const selectTelemetryChartData = (state) => state.telemetryChartData;
export const { setTelemetryChartData, setTelemetryIntervalUnit } =
  telemetryChartDataSlice.actions;
